import React, { useEffect, useState } from 'react';
import { Heart, Languages } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { NAV_LINKS } from '../mock';
import { useLanguage } from '../i18n/LanguageContext';
import { useDonate } from '../donate/DonateContext';

const Header = () => {
  const { t, toggleLang } = useLanguage();
  const { openDonate } = useDonate();
  const [active, setActive] = useState('home');
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (location.pathname === '/governing-council') setActive('council');
  }, [location.pathname]);

  const handleNav = (e, link) => {
    e.preventDefault();
    setActive(link.id);
    if (link.type === 'route') {
      navigate(link.href);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const target = document.getElementById(link.scrollId || link.id);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 80);
    } else {
      const target = document.getElementById(link.scrollId || link.id);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleDonate = () => openDonate();

  return (
    <header className={`jbss-header ${scrolled ? 'jbss-header-scrolled' : ''}`}>
      <div className="jbss-header-inner">
        <a
          href="/"
          onClick={(e) => { e.preventDefault(); navigate('/'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
          className="jbss-brand"
        >
          <span className="jbss-logo-slogan" aria-label="Educate, Organize and Agitate">
            <span>Educate</span>
            <span>Organize</span>
            <span>Agitate</span>
          </span>
          <span className="jbss-brand-text">
            <span className="jbss-brand-name" data-testid="header-brand-name">{t('brand.name')} {t('brand.registered')}</span>
            <span className="jbss-brand-tag">{t('brand.tagline')}</span>
            <span className="jbss-brand-reg" data-testid="header-reg-no">{t('brand.regNo')}</span>
          </span>
        </a>

        <nav className="jbss-nav">
          {NAV_LINKS.map((link) => (
            <a
              key={link.id}
              href={link.href}
              onClick={(e) => handleNav(e, link)}
              className={`jbss-nav-link ${active === link.id ? 'jbss-nav-link-active' : ''}`}
            >
              {t(link.tKey)}
            </a>
          ))}
          <button
            className="jbss-nav-admin"
            onClick={() => { navigate('/admin'); window.scrollTo({ top: 0 }); }}
            data-testid="nav-admin-link"
          >
            {t('nav.admin')}
          </button>
        </nav>

        <div className="jbss-header-actions">
          <button className="jbss-lang-btn" aria-label="Switch language" onClick={toggleLang} data-testid="lang-toggle">
            <Languages size={16} />
            <span>{t('common.switchLang')}</span>
          </button>
          <button className="jbss-donate-btn" onClick={handleDonate} data-testid="header-donate">
            <Heart size={16} fill="currentColor" />
            <span>{t('nav.donate')}</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
